import { createFeature } from '@ngrx/store';
import { Address } from 'src/app/models/address.model';

import { AppSettings } from 'src/app/models/app-settings.model';
import { SoilInfo } from 'src/app/models/soil-info.model';
import { ElasticLocation } from 'src/app/services/request-models/elastic-api.model';

import { CompanyInfo } from './../../models/company-info.model';
import SettingsReducer from './reducer';

export interface SettingsState {
  address: Address | undefined;
  companyInfo: CompanyInfo | undefined;
  soilInfo: SoilInfo | undefined;
  appSettings: AppSettings | undefined;
  locations: ElasticLocation[] | undefined;
  selectedLocation: ElasticLocation | undefined;
}

export const settingsFeatureKey = 'settings';

export const settingsFeature = createFeature({
  name: settingsFeatureKey,
  reducer: SettingsReducer,
});
